import Immutable from 'immutable'
import moment from 'moment'

const fields = {
  cancelled: null,
  cancelledBy: null, // id
  cancellerIp: null,
  cancellerRequestId: null,
  clientId: null,
  creator: null, // id
  creatorIp: null,
  dateAdded: null,
  dateUpdated: null,
  id: null,
  requestId: null,
  userAgent: null,
}

export default class PartnerRelationship extends Immutable.Record(fields) {
  constructor({
    cancelled,
    cancelledBy,
    client_id: clientId,
    creator,
    dateAdded,
    dateUpdated,
    ...data
  } = {}) {
    super({
      cancelled: cancelled ? moment(cancelled) : null,
      cancelledBy: cancelledBy ? cancelledBy.id : null,
      clientId,
      creator: creator ? creator.id : null,
      dateAdded: dateAdded ? moment(dateAdded) : null,
      dateUpdated: dateUpdated ? moment(dateUpdated) : null,
      ...data,
    })
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/PartnerRelationship.js